/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { unsetUserData } from '@/redux/slices/user/actions';

import { SettingsOverviewState } from './types';

const initialState: SettingsOverviewState = {
  collapsed: false,
  latestUpdatedAt: 0,
};

const settingsOverviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    setOverviewCollapsed: (state, { payload }: PayloadAction<boolean>) => {
      state.collapsed = payload;
    },
    setOverviewLatestUpdatedAt: (state, { payload }: PayloadAction<number>) => {
      state.latestUpdatedAt = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unsetUserData, () => initialState);
  },
});

export default settingsOverviewSlice;
